import React from 'react';
import './WhyUs.css';
import giftSvg from '../../../images/icon/gift.svg';
import lightSvg from '../../../images/icon/light.svg';
import clockSvg from '../../../images/icon/clock.svg';
import peopleSvg from '../../../images/icon/people.svg';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import bubbleGif from '../../../images/gif/bubble.gif';

const WhyUs = () => {
    return (
        <div style={{backgroundImage: `url(${bubbleGif})`, backgroundSize: 'cover', backgroundPosition: 'center', color: 'white', padding: '20px 20px 200px 20px', borderRadius: 20}}>
            <div style={{ marginTop: '30px' }} className="d-flex justify-content-between">
                <h1 data-aos="fade-up" data-aos-duration="2000"  className="fw-bolder">Why <span style={{ color: '#ff3465' }}>us</span>?</h1>
                <div>
                    <Link to="/about" className="btn rounded-pill btn-global-style">
                        About us <FontAwesomeIcon icon={faArrowRight} />
                    </Link>
                </div>
            </div>
            <div className="row mt-3 mb-5">
                <div data-aos="flip-left" data-aos-duration="1500"  className="col-xl-3 col-md-4 col-sm-6 col-12 text-center mt-2  p-2">
                    <div className="why-us-div" style={{ background: '#5a2274', color: 'white', padding: '30px 10px', borderRadius: 10, cursor: 'pointer' }}>
                        <img className="mb-3" src={giftSvg} alt="" />
                        <h5>Ready projects</h5>
                        <p>Ultricies mattis mauris aliquetumis. Lacus sagittis.</p>
                    </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6 col-12 text-center mt-2  p-2">
                    <div data-aos="flip-left" data-aos-duration="2000"  className="why-us-div" style={{ background: 'rgb(235, 199, 0)', color: 'black', padding: '30px 10px', borderRadius: 10, cursor: 'pointer' }}>
                        <img className="mb-3" src={lightSvg} alt="" />
                        <h5>Original ideas</h5>
                        <p>Himenaeos commodo justo rutrum nibh lectus ipsum.</p>
                    </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6 col-12 text-center mt-2  p-2">
                    <div data-aos="flip-left" data-aos-duration="2500"  className="why-us-div" style={{ background: '#ff6060', color: 'white', padding: '30px 10px', borderRadius: 10, cursor: 'pointer' }}>
                        <img className="mb-3" src={clockSvg} alt="" />
                        <h5>Fast turnaround time</h5>
                        <p>In convallis cursus habitant commodo mattis sapien.</p>
                    </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6 col-12 text-center mt-2  p-2">
                    <div data-aos="flip-left" data-aos-duration="3000"  className="why-us-div" style={{ background: '#ff3465', color: 'white', padding: '30px 10px', borderRadius: 10, cursor: 'pointer' }}>
                        <img className="mb-3" src={peopleSvg} alt="" />
                        <h5>Unlimited people</h5>
                        <p>Suspendisse placerat lacinia fusce condimentum.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhyUs;